import ModalDefault from "../ModalDefault";
import InputBox from "../InputBox";
import SelectBox from "../SelectBox/SelectBox";
import { StyledBtn } from "../../styles/Buttons";

//LIBS
import { useForm } from "react-hook-form";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";

//RESOLVER
import { newTechSchema } from "../../schemas/schemas";

//CONTEXT
import { useContext } from "react";
import { TechContext } from "../../context/TechContext";


const AddModal = ({title, closeModal})=>{

    const { submitTech } = useContext(TechContext);

    const { register, handleSubmit, formState:{errors}, reset } = useForm({ 
        mode: "onBlur",
        resolver: yupResolver(newTechSchema)
    });

    return(
        <ModalDefault callback={handleSubmit(submitTech)} closeModal={closeModal} title="Cadastrar Tecnologia">
            <InputBox
                label="Nome" name="project-title"
                type="text" register={register("title")}
                placeholder="Insira o título" errors={errors.title}
                />

            <SelectBox
                label="Selecionar Status" name="project-status"
                register={register("status")} errors={errors.status}
            >
                <option>Insira o seu nível</option>
                <option value="Iniciante">Iniciante</option>
                <option value="Intermediário">Intermediário</option>
                <option value="Avançado">Avançado</option>
            </SelectBox>
            <StyledBtn size="100%" BGcolor="var(--color-primary)">Cadastrar Tecnologia</StyledBtn>
        </ModalDefault>
    )
}

export default AddModal